import { ImagesIcon as PhosphorImagesIcon } from "@phosphor-icons/react/dist/ssr/Images";

import { createAppIcon } from "@/components/createAppIcon";

export const PhotoLibraryIcon = /* @__PURE__ */ createAppIcon(PhosphorImagesIcon);
